module.exports = "/static/media/smersever.ea6fb0e9.jpg";